import { render, staticRenderFns } from "./AncestrylineTab.vue?vue&type=template&id=2c126cac&scoped=true"
import script from "./AncestrylineTab.vue?vue&type=script&lang=js"
export * from "./AncestrylineTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c126cac",
  null
  
)

export default component.exports